import React, { useEffect, useState } from "react";
import StatusDropdown from "../Shared/StatusDropdown";
import { useNavigate } from "react-router-dom";
export default function CouponsForm({
  onSubmit,
  loading = false,
  isEdit = false,
  initialData = {},
}) {
  const navigate = useNavigate();
  const initialState = {
    title: "",
    code: "",
    description: "",
    discountType: "PERCENTAGE",
    applicableCategory: "",
    discountValue: "",
    minOrderAmount: "",
    maxDiscountAmount: "",
    startDate: "",
    expiryDate: "",
    totalUsageLimit: "",
    status: "ACTIVE",
  };

  const [formData, setFormData] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setFormData({
        code: initialData.code || "",
        title: initialData.title || "",
        description: initialData.description || "",
        discountType: initialData.discountType || "PERCENTAGE",
        applicableCategory: initialData.applicableCategory?._id || initialData.applicableCategory || "",
        discountValue: initialData.discountValue || "",
        minOrderAmount: initialData.minOrderAmount || "",
        maxDiscountAmount: initialData.maxDiscountAmount || "",
        startDate: initialData.startDate
          ? initialData.startDate.split("T")[0]
          : "",
        expiryDate: initialData.expiryDate
          ? initialData.expiryDate.split("T")[0]
          : "",
        totalUsageLimit: initialData.totalUsageLimit || "",
        status: initialData.status || "ACTIVE",
      });
    }
  }, [initialData]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    setErrors((prev) => ({
      ...prev,
      [name]: "",
    }));
  };

  //  SUBMIT
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (formData.totalUsageLimit !== "" && Number(formData.totalUsageLimit) < 0) {
      setErrors((prev) => ({
        ...prev,
        totalUsageLimit: "Total usage limit cannot be negative",
      }));
      return;
    }

    const payload = {
      code: formData.code,
      title: formData.title,
      description: formData.description,
      discountType: formData.discountType.toUpperCase(),
      applicableCategory: formData.applicableCategory,
      discountValue: Number(formData.discountValue),
      minOrderAmount: Number(formData.minOrderAmount),
      maxDiscountAmount: Number(formData.maxDiscountAmount),
      startDate: formData.startDate,
      expiryDate: formData.expiryDate,
      totalUsageLimit: Number(formData.totalUsageLimit),
      status: formData.status,
    };


    try {
      setErrors({});

      const response = await onSubmit(payload);

    

      if (response?.status === 422 || response?.success === false) {
        setErrors(response.error || {});
        return;
      }

      setSuccessMessage(
        isEdit ? "Coupon Updated Successfully" : "Coupon Added Successfully",
      );

      if (!isEdit) {
        setFormData(initialState);
      }

      setTimeout(() => {
        setSuccessMessage("");
        navigate("/coupon");
      }, 2000);
    } catch (error) {
      
    }
  };

  return (
    <div className="container-fluid p-4">
      <div className="card border-2"
        style={{
          backgroundColor: "#fff",
          borderRadius: "12px",
          padding: "20px",
        }}
      >
        

        {successMessage && (
          <div className="alert alert-success">{successMessage}</div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="row g-3">
            <div className="col-md-4">
              <label className="form-label fw-semibold">
                Title <span className="error">*</span>
              </label>
              <input
                type="text"
                name="title"
                className="form-control"
                value={formData.title}
                onChange={handleChange}
              />
              {errors.title && <small className="error">{errors.title}</small>}
            </div>
            <div className="col-md-4">
              <label className="form-label fw-semibold">
                Code <span className="error">*</span>
              </label>
              <input
                type="text"
                name="code"
                className="form-control"
                value={formData.code}
                onChange={handleChange}
              />
              {errors.code && <small className="error">{errors.code}</small>}
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">
                Discount Type <span className="error">*</span>
              </label>
              <select
                name="discountType"
                className="form-control"
                value={formData.discountType}
                onChange={handleChange}
              >
                <option value="PERCENTAGE">Percentage</option>
                <option value="FLAT">Flat</option>
              </select>
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">
                Discount Value <span className="error">*</span>
              </label>
              <input
                type="number"
                name="discountValue"
                className="form-control"
                value={formData.discountValue}
                onChange={handleChange}
              />
              {errors.discountValue && (
                <small className="error">{errors.discountValue}</small>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">
                Min Order Amount <span className="error">*</span>
              </label>
              <input
                type="number"
                name="minOrderAmount"
                className="form-control"
                value={formData.minOrderAmount}
                onChange={handleChange}
              />
              {errors.minOrderAmount && (
                <small className="error">{errors.minOrderAmount}</small>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">
                Max Discount <span className="error">*</span>
              </label>

              <input
                type="number"
                name="maxDiscountAmount"
                className="form-control"
                value={formData.maxDiscountAmount}
                onChange={handleChange}
              />

              {errors.maxDiscountAmount && (
                <small className="error">{errors.maxDiscountAmount}</small>
              )}
            </div>


            <div className="col-md-4">
              <label className="form-label fw-semibold">
                Applicable Category <span className="error">*</span>
              </label>

              <input
                type="text"
                name="applicableCategory"
                className="form-control"
                value={formData.applicableCategory}
                onChange={handleChange}
                placeholder="Enter Category Id"
              />

              {errors.applicableCategory && (
                <small className="error">{errors.applicableCategory}</small>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">
                Start Date <span className="error">*</span>
              </label>

              <input
                type="date"
                name="startDate"
                className="form-control"
                value={formData.startDate}
                onChange={handleChange}
              />

              {errors.startDate && (
                <small className="error">{errors.startDate}</small>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">
                Expiry Date<span className="error">*</span>
              </label>
              <input
                type="date"
                name="expiryDate"
                className="form-control"
                value={formData.expiryDate}
                onChange={handleChange}
              />
              {errors.expiryDate && (
                <small className="error">{errors.expiryDate}</small>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">
                 TotalUsageLimit <span className="error">*</span>
              </label>
              <input
                type="number"
                name="totalUsageLimit"
                className="form-control"
                min="0"
                value={formData.totalUsageLimit}
                onChange={handleChange}
              />
              {errors.totalUsageLimit && (
                <small className="error">{errors.totalUsageLimit}</small>
              )}
            </div>

            <div className="col-md-4">
              <label className="form-label fw-semibold">
                Status<span className="error">*</span>
              </label>
              <StatusDropdown
                name="status"
                className="form-control"
                value={formData.status}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-12">
              <label className="form-label fw-semibold">
                Description <span className="error">*</span>
              </label>
              <textarea
                rows="4"
                name="description"
                className="form-control"
                value={formData.description}
                onChange={handleChange}
              />
              {errors.description && (
                <small className="error">{errors.description}</small>
              )}
            </div>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <button
              type="submit"
              className="btn btn-primary"
              disabled={loading}
            >
              {loading
                ? "Submitting..."
                : isEdit
                  ? "Update Coupon"
                  : "Add Coupon"}
            </button>

            <button
              type="button"
              className="btn"
              style={{ backgroundColor: "#032B4D", color: "#fff" }}
              onClick={() => navigate("/coupon")}
            >
              Cancel
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
